import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { loginUser } from "./actions/authentication.action";
import { Apis } from "../../util/Apis";
import AuthContext from "./store/AuthContext";
import { CardLogin, ContenidoLogin, LoginContainer, SalaContent, TextError } from "./loginElements";
import { useLocation, useNavigate } from "react-router";
import { BsFacebook, BsInstagram, BsWhatsapp } from "react-icons/bs";
import { Button, Input, Label } from "../atoms";
import { LuEye, LuEyeClosed } from "react-icons/lu";
import logoFullWargos from "../../assets/imgs/logo-wargos.png";
import logoclub from "../../assets/imgs/carnavalclub.png"

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Login = () => {
  const { stateUser, dispatch } = useContext(AuthContext);
  const [referer, setReferer] = useState("/home");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const query = useQuery();

  const [checkPassword, setCheckPassword] = useState(false);
  const [selectCasino, setSelectCasino] = useState(false);
  const [sala, setSala] = useState({ name: " " });
  const [siteInfo, setSiteInfo] = useState(null);

  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  useEffect(() => {
    getSalas();

    let checkSala = localStorage.getItem("salaInfo");
    if (checkSala !== undefined && checkSala !== null) {
      setSala(JSON.parse(checkSala));
      setSelectCasino(true);
    }
    const redirectTo = query.get("redirect");
    //console.log('redirectTo: ' + redirectTo)
    if (redirectTo && redirectTo !== "") {
      setReferer(redirectTo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cambiarSala = () => {
    setSelectCasino(false);
    localStorage.removeItem("salaInfo");
  };

  function doLogin() {
    if (username === "" || password === "") {
      setError("Ingrese datos correctamente");
    } else {
      loginUser(username, password, sala.auth, dispatch, setError, setLoading);
    }
  }

  function getSalas() {
    axios
      .get(Apis.CAPP + "/site")
      .then(function (response) {
        setSiteInfo(response.data);
      })
      .catch(function (error) {});
  }

  function verifyUserAccount() {
    setError("");
    setLoading(true);
    if (username === "") {
      setError("Ingrese datos correctamente");
      setLoading(false);
      return;
    }

    let params = { document: username, salaId: sala.salaId };
    axios
      .get(Apis.CAPP + "/verify-account", { params: params })
      .then(function (response) {
        setLoading(false);
        if (!response.data.exists) {
          setError("Acerquese al counter para afiliarse al club de jugadores");
          return;
        }

        if (response.data.account) {
          setCheckPassword(true);
        } else {
          navigate("/sign-up/" + username);
        }
      })
      .catch(function () {
        setLoading(false);
        setError("Hubo un error");
      });
  }

  const isLoggedIn = stateUser.isAuthenticated;

  if (isLoggedIn) {
    console.log("is logged in");
    return <Navigate to={referer} />;
  }

  const handleLogin = (data, setSelectCasino, setSala) => {
    localStorage.setItem("salaInfo", JSON.stringify(data));
    setSelectCasino(true);
    setSala(data);
  };

  return (
    <LoginContainer>
      {siteInfo && (
        <CardLogin isSelect={selectCasino}>
          <ContenidoLogin>
            <div className="flex flex-col items-center justify-center w-[120px] h-[120px] bg-white p-0">
              <img
                src={logoclub}
                alt="logo"
                className="w-auto h-auto max-h-[120px] max-w-[120px] rounded-2xl"
              />
            </div>
            {selectCasino ? (
              <>
                <div className="flex flex-col items-center justify-center w-full gap-2">
                  <span className="text-xl font-bold leading-none uppercase text-slate-950">
                    {sala.name}{" "}
                  </span>
                  <span
                    className="text-sm font-medium leading-none cursor-pointer text-primary"
                    onClick={cambiarSala}
                  >
                    cambiar sala
                  </span>
                </div>
                <form className="flex flex-col w-full gap-4 p-4">
                  <div className="flex flex-col w-full">
                    <Label id="labeldocument">Documento</Label>
                    <Input
                      required
                      autoFocus
                      autoComplete="off"
                      type="tel"
                      id="document"
                      htmlFor="labeldocument"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>

                  {checkPassword ? (
                    <>
                      <div className="relative flex flex-col w-full">
                        <Label id="labelcontrasena">Contraseña</Label>
                        <Input
                          required
                          type={passwordShown ? "text" : "password"}
                          id="contrasena"
                          htmlFor="labelcontrasena"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <div className="absolute bottom-2.5 right-3.5">
                          {passwordShown ? (
                            <LuEye size={18} onClick={togglePassword} />
                          ) : (
                            <LuEyeClosed size={18} onClick={togglePassword} />
                          )}
                        </div>
                      </div>
                      <Button type="submit" onClick={doLogin} disabled={loading}>
                        {loading ? "Cargando" : "Ingresar"}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button type="submit" onClick={verifyUserAccount} disabled={loading}>
                        {loading ? "Cargando" : "Validar"}
                      </Button>
                    </>
                  )}
                </form>

                <TextError>{error}</TextError>

                <div className="flex flex-col items-center justify-center w-full gap-2">
                  <label>{siteInfo.name}</label>
                  <div className="flex flex-row items-center justify-center gap-4">
                    <a href={sala.facebook} target="_blank" rel="noopener noreferrer">
                      <BsFacebook size={26} />
                    </a>
                    {sala.instagram != null && (
                      <a href={sala.instagram} target="_blank" rel="noopener noreferrer">
                        <BsInstagram size={26} />
                      </a>
                    )}
                    <a href={sala.whatsapp} target="_blank" rel="noopener noreferrer">
                      <BsWhatsapp size={26} />
                    </a>
                  </div>
                </div>
                <div className="absolute transform -translate-x-1/2 bottom-8 left-1/2">
                  <img src={logoFullWargos} alt="logo" className="w-auto h-10" />
                </div>
              </>
            ) : (
              <>
                <span className="text-sm text-blue-600">
                  Seleccione el casino de su preferencia:
                </span>
                <SalaContent>
                  {siteInfo &&
                    siteInfo.salas.map((data, key) => (
                      <div
                        className="flex flex-col items-center justify-center gap-4 p-6 bg-white cursor-pointer shadow-regular rounded-2xl"
                        key={key}
                      >
                        <img
                          src={data.path}
                          rel="preload"
                          alt={data.name}
                          className="w-[160px] h-auto"
                          onClick={() => handleLogin(data, setSelectCasino, setSala)}
                        />
                        <span className="text-lg font-semibold text-center">{data.name}</span>
                      </div>
                    ))}
                </SalaContent>
              </>
            )}
          </ContenidoLogin>
        </CardLogin>
      )}
    </LoginContainer>
  );
};

export default Login;
